export const isReferrerSameHost = (
  document: Pick<Document, 'referrer' | 'location'>
): boolean => {
  if (!document.referrer) {
    return false
  }
  const referrerHost = new URL(document.referrer).hostname
  const currentHost = document.location.hostname

  return referrerHost === currentHost
}
